export default __webpack_public_path__ + "static/media/studentDelete.0eb715c0.svg";